export const DOWNSELL_PLAN_IDS: Record<'discount_30' | 'discount_50', string> =
  {
    discount_30: '7359b72b-6a49-464e-ba5f-c034a5dbbc92',
    discount_50: 'f208682c-fa47-413f-b3e2-f88bb6ffdb6b',
  };
